import common from './vi-VN/common';
import login from './vi-VN/login';
const local = {
    ...common,
    ...login,
}

export default local;